import React from 'react';
import { InstagramEmbed } from 'react-social-media-embed';

function InstagramPost() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', margin: '20px' }}>
      <InstagramEmbed
        url="https://www.instagram.com/p/CaUNdE-hXwd/"
        width={600}
        captioned={false}
      />
    </div>
  );
}

export default InstagramPost;